import React from "react";
import { Navigate } from "react-router-dom";
import Login from "../Pages/Auth/Login";
import ForgetPassword from "../Pages/Auth/ForgetPassword";
import LabList from "../Pages/Lab/LabList";
import { LabAdd } from "../Pages/Lab/LabAdd";
import UsersList from "../Pages/Users/UsersList";
import { UsersEdit } from "../Pages/Users/UsersEdit";
import { UsersAdd } from "../Pages/Users/UsersAdd";
import { LabEdit } from "../Pages/Lab/LabEdit";

import PatientList from "../Pages/Patients/PatientList";
import { PatientEdit } from "../Pages/Patients/PatientEdit";
import { PatientAdd } from "../Pages/Patients/PatientAdd";
import { LabDiagnosisAdd } from "../Pages/LabDiagnosis/LabDiagnosisAdd";
import { LabDiagnosisEdit } from "../Pages/LabDiagnosis/LabDiagnosisEdit";
import LabDiagnosisList from "../Pages/LabDiagnosis/LabDiagnosisList";
import MedicinesList from "../Pages/Medicines/MedicinesList";
import { MedicinesAdd } from "../Pages/Medicines/MedicinesAdd";
import { MedicinesEdit } from "../Pages/Medicines/MedicinesEdit";
import MedicineDetailsList from "../Pages/MedicineDetails/MedicineDetailsList";
import { MedicineDetailsAdd } from "../Pages/MedicineDetails/MedicineDetailsAdd";
import {MedicineDetailsEdit} from "../Pages/MedicineDetails/MedicineDetailsEdit";
import { Dashboard } from "../Pages/Dashboard/dashboard";
import EmployeeList from "../Pages/Employee/EmployeeList";
import { EmployeeAdd } from "../Pages/Employee/EmployeeAdd";
import { EmployeeEdit } from "../Pages/Employee/EmployeeEdit";
import JobList from "../Pages/Jobs/JobList";
import { JobAdd } from "../Pages/Jobs/JobAdd";
import { JobEdit } from "../Pages/Jobs/JobEdit";
import JobApplicationsList from "../Pages/JobApplications/JobApplicationsList";
import { JobApplicationsAdd } from "../Pages/JobApplications/JobApplicationsAdd";
import { JobApplicationsEdit } from "../Pages/JobApplications/JobApplicationsEdit";

const authProtectedRoutes = [
  //dashboard
  // { path: "/dashboard", component: <Dashboard /> },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/users" />,
  },
  // {
  //    path:"dashboard",
  //    component:<Dashboard/>
  // },
  {
    path:"users",
    component: <UsersList/>,
  },
  {
    path:"users/add",
    component: <UsersAdd/>,
  },
  {
    path:"users/edit/:id",
    component: <UsersEdit/>,
  },
  {
    path:"job-seakers",
    component: <EmployeeList/>,
  },
  {
    path:"job-seakers/add",
    component: <EmployeeAdd/>,
  },
  {
    path:"job-seakers/edit/:id",
    component: <EmployeeEdit/>,
  },
  {
    path:"jobs",
    component: <JobList/>,
  },
  {
    path:"job/add",
    component: <JobAdd/>,
  },
  {
    path:"job/edit/:id",
    component: <JobEdit/>,
  },
  {
    path:"job-applications",
    component: <JobApplicationsList/>,
  },
  {
    path:"job-application/add",
    component: <JobApplicationsAdd/>,
  },
  {
    path:"job-application/edit/:id",
    component: <JobApplicationsEdit/>,
  }
 
];
const PatientsRoutes = [
  {
    path:"",
    component: <Navigate to="/patients" />,
  },
  {
    path: "patients",
    component: <PatientList />,
  },
  {
    path: "patient/add",
    component: <PatientAdd />,
  },
  {
    path: "patient/edit/:id",
    component: <PatientEdit />,
  },

];
const LabRoutes = [
  {
    path:"",
    component: <Navigate to="/lab" />,
  },
  {
    path: "lab",
    component: <LabList />,
  },
  {
    path: "lab/add",
    component: <LabAdd />,
  },
  {
    path: "lab/edit/:id",
    component: <LabEdit/>,
  },



];

const PharmacistRoutes = [
  {
  path:"",
  component: <Navigate to="/medicines" />,
},
{
  path: "medicines",
  component: <MedicinesList />,
},
{
  path: "medicines/add",
  component: <MedicinesAdd />,
},
{
  path: "medicines/edit/:id",
  component: <MedicinesEdit/>,
},
]


const publicRoutes = [
  { path: "/logout", component: <Login /> },
  { path: "/login", component: <Login /> },
  { path: "/forgetpassword", component: <ForgetPassword /> },
  
  

];

export { authProtectedRoutes, publicRoutes ,PatientsRoutes, LabRoutes, PharmacistRoutes};
